module.exports = require('./../../dist/src/on-stage/system/dist/components/CheckXSmall.js');
